import { render } from "./CvSection.vue?vue&type=template&id=d785eca0"
import script from "./CvSection.vue?vue&type=script&lang=js"
export * from "./CvSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__